import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { getLightBorder } from 'Components/utils';
import FacetPlanSummaryKabobMenu from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/FacetPlanSummaryKabobMenu';
import ScenarioLoadingIndicator
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/ScenarioLoadingIndicator';
import ReadOnlyScenarioChip
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/ReadOnlyScenarioChip';
import useDebugPanel from 'Components/UI/DebugPanel/useDebugPanel';
import fr from 'facet-rest';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';

const styles = (theme) => ({
  root: {
    position: 'relative',
  },
  rowAligned: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  headerContentContainer: {
    padding: theme.spacing(2),
    ...getLightBorder(theme, { bottom: true }),
    width: '100%',
  },
  buttonHolder: {
    paddingRight: theme.spacing(1),
  },
  text: {
    flexGrow: 1,
  },
  readonlyChip: {
    marginTop: theme.spacing(2),
  },
});

const Header = ({
  className,
  classes,
}) => {
  const { pageContentResource } = usePageContentContext();

  const isReadonly = pageContentResource.attr('isReadonly') === 'true';

  const {
    showing,
  } = useDebugPanel();

  const handleDownloadClick = async () => {
    window.open(pageContentResource?.relationship(fr.relationships.export.name)?.link('related').url(), '_blank', 'noreferrer noopener nofollow');
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={
        classNames(classes.headerContentContainer)}
      >
        <Box className={classes.rowAligned}>
          <Text
            className={classes.text}
            text={pageContentResource.attr('scenarioName')}
            variant={'h3'}
            weight={'bold'}
            color={'primary'}
            align={'left'}
            noWrap
          />
          <FacetPlanSummaryKabobMenu />
        </Box>
        {!isReadonly ? (
          <ScenarioLoadingIndicator />)
          : null}
        {isReadonly ? (
          <ReadOnlyScenarioChip
            className={classes.readonlyChip}
            resource={pageContentResource}
          />
        ) : null}
        {pageContentResource?.relationship(fr.relationships.export.name) && showing && (
        <IconButton
          icon={DownloadIcon}
          color={'naturalGreen'}
          size={'small'}
          onClick={async () => handleDownloadClick()}
        />
        )}
      </div>
    </Box>
  );
};

Header.defaultProps = {
  className: '',
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
